import { Component, OnInit } from '@angular/core';
import { IServiceList, IServicePost, ServicesPageService } from '../../services-page.service';

@Component({
  selector: 'app-service-social-marketing',
  templateUrl: './service-social-marketing.component.html',
  styleUrls: ['./service-social-marketing.component.css']
})
export class ServiceSocialMarketingComponent implements OnInit {
  
  constructor() {}

  ngOnInit(): void {
  }
}
